import { render, staticRenderFns } from "./QuestionsTable.vue?vue&type=template&id=07f9e1e2&"
import script from "./QuestionsTable.vue?vue&type=script&lang=ts&"
export * from "./QuestionsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports